module.exports = __webpack_public_path__ + "fonts/Figtree-Medium.fd253f4.woff2";